import React, { useCallback } from 'react'
import { FormattedMessage } from 'react-intl'

import { TtButton, TtPoll, TtPollAnswer } from '@23/ui-react'

import { useEndPollMutation } from '../../../hooks/use-polls'
import { type Poll } from '../../../models/poll'

import { useClosePollConfirmationModal } from './EndPollConfirmation/CloseConfirmation'

interface StartedPollProps {
  poll: Poll
}

const StartedPoll = ({ poll }: StartedPollProps) => {
  const closePollConfirmationModal = useClosePollConfirmationModal()
  const { mutateAsync: endPoll, isLoading } = useEndPollMutation(poll.id)

  const handleClosePoll = useCallback(async () => {
    const confirmation = await closePollConfirmationModal()
    if (confirmation) {
      await endPoll()
    }
  }, [closePollConfirmationModal, endPoll])

  return (
    <>
      <TtPoll label={poll.question}>
        {poll.options.map((option) => (
          <TtPollAnswer
            key={option.id}
            label={option.option}
            value={option.count}
          />
        ))}
      </TtPoll>
      <TtButton
        color="secondary"
        size="small"
        variant="outline"
        pill
        loading={isLoading}
        disabled={isLoading}
        onClick={handleClosePoll}
      >
        <FormattedMessage defaultMessage="Close Poll" />
      </TtButton>
    </>
  )
}

export { StartedPoll }
